import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCallButton } from "./components/FloatingCallButton";
import { HomePage } from "./pages/HomePage";
import { VaughanPage } from "./pages/VaughanPage";
import { RichmondHillPage } from "./pages/RichmondHillPage";
import { BlogPage } from "./pages/BlogPage";
import { TorontoPage } from "./pages/TorontoPage";
import { NorthYorkPage } from "./pages/NorthYorkPage";
import { EastYorkPage } from "./pages/EastYorkPage";
import { WoodbridgePage } from "./pages/WoodbridgePage";
import { MarkhamPage } from "./pages/MarkhamPage";
import { KingCityPage } from "./pages/KingCityPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vaughan-appliance-repair" element={<VaughanPage />} />
            <Route path="/richmond-hill-appliance-repair" element={<RichmondHillPage />} />
            <Route path="/toronto-appliance-repair" element={<TorontoPage />} />
            <Route path="/north-york-appliance-repair" element={<NorthYorkPage />} />
            <Route path="/east-york-appliance-repair" element={<EastYorkPage />} />
            <Route path="/woodbridge-appliance-repair" element={<WoodbridgePage />} />
            <Route path="/markham-appliance-repair" element={<MarkhamPage />} />
            <Route path="/king-city-appliance-repair" element={<KingCityPage />} />
            <Route path="/blog" element={<BlogPage />} />
          </Routes>
        </div>
        <Footer />
        <FloatingCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
